/**
 * Injects a `<link rel="preload" as="image">` so the browser fetches the image immediately at high priority.
 * Use when navigation to the screen that needs this image is imminent (e.g. user just made a selection).
 * No-op if already present.
 */
export function preloadImage(url: string): void {
  if (!url) return
  if (document.querySelector(`link[rel="preload"][href="${url}"]`)) return
  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'image'
  link.href = url
  document.head.appendChild(link)
}
